import React from 'react'
import './ContactForm.css';
import InputField from '../../ControlledComponents/InputField/InputField'
import PrimeryButton from '../../ControlledComponents/PrimeryButton/PrimeryButton';
import { FaFacebookF } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa6";
import { FaTwitter } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaVimeoV } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6";
import MainHeading from '../../GlobalComponents/Utils/mainHeading';
import { useTranslation } from "react-i18next";


const ContactForm = ({titleOne, titleTwo}) => {
    const { t ,i18n} = useTranslation();
    const socialIcons = [
         { link: 'https://www.facebook.com/profile.php?id=61574574331628', icon: <FaFacebookF size={20} /> },
                { link: 'https://www.instagram.com/thefilmarz', icon: <FaInstagram size={20} /> },
                { link: 'https://www.tiktok.com/@thefilmarz?lang=en', icon: <FaTiktok size={20} /> },
                { link: 'https://x.com/ArzFilm5785', icon: <FaXTwitter size={20} /> },
                { link: 'https://www.linkedin.com/in/the-filmarz-42b17a358/', icon: <FaLinkedinIn size={20} /> },
                { link: 'https://www.youtube.com/@FilmarzProd', icon: <FaYoutube size={20} /> },
                { link: 'https://vimeo.com/user237514222', icon: <FaVimeoV size={20} /> }
    ]
  return (
    <div className='contact-us-main-div'>
        <div className='contact-left-section'>
            <h3 className='contact-heading'> {t("contactform.firstpart")} <span> {t("contactform.secondpart")} </span></h3>
            {/* <MainHeading content1={"Let's Create and"} align={"start"} content2={" Collaborate"} /> */}
            <p className='contact-desc'>
                {t("contactform.para")}
            </p>
            <h3 className='contact-follow'>{t("contactform.firstpart1")} <span>{t("contactform.secondpart1")}</span></h3>
            <div className='contact-social-icons'>
                {socialIcons.map((items, index) => (
                    <a href={items.link}>{items.icon}</a>
                ))}
            </div>
        </div>
        <div className='contact-right-section'>
            <InputField 
                type={'text'} 
                placeholder={t("contactform.name")}
                width={'425px'}
                // height={'50px'}
                textAlign={'start'}
                padding={'12px 23px'}
                fontSize={'17px'}
                lineHeight={'25px'}
                fontWeight={'500'}
                color={'#fff'}
                borderRadius={'10px'}
            />
            <InputField 
                type={'text'} 
                placeholder={t("contactform.email")}
                width={'425px'}
                // height={'50px'}
                textAlign={'start'}
                padding={'12px 23px'}
                fontSize={'17px'}
                lineHeight={'25px'}
                fontWeight={'500'}
                color={'#fff'}
                borderRadius={'10px'}
            />
            <InputField 
                type={'text'} 
                placeholder={t("contactform.number")}
                width={'425px'}
                // height={'50px'}
                textAlign={'start'}
                padding={'12px 23px'}
                fontSize={'17px'}
                lineHeight={'25px'}
                fontWeight={'500'}
                color={'#fff'}
                borderRadius={'10px'}
            />
            <InputField 
                type={'text'} 
                placeholder={t("contactform.subject")}
                width={'425px'}
                // height={'50px'}
                textAlign={'start'}
                padding={'12px 23px'}
                fontSize={'17px'}
                lineHeight={'25px'}
                fontWeight={'500'}
                color={'#fff'}
                borderRadius={'10px'}
            />
            <textarea rows={3} placeholder={t("contactform.message")} className='text-message' />
            <PrimeryButton 
                text={t("contactform.button")} 
                width={'182px'} 
                height={'50px'} 
                padding={'2px 10px'}
                fontSize={'17px'}
                lineHeight={'25px'}
                fontWeight={'600'}
                color={'#fff'}
                arrowTrue={false}
            />
        </div>
    </div>
  )
}

export default ContactForm
